/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColProps } from './type';
const props: TdColProps = {
  /** 列的偏移量（默认单位px） */
  offset: {
    type: null,
  },
  /** 列的宽度（默认单位px） */
  span: {
    type: null,
  },
};

export default props;
